import { call, put, takeLatest } from "redux-saga/effects"
import { GET_DATA_NPS_WATCHER } from "./constants"

import { getDataNpsSuccess, getDataNpsFailed } from "./actions"
import { getDataEnpsApi } from "../../../utils/routes/routes-report"

export function* getDataNpsSaga(action) {
  try {
    const dataStatus = action.payload
    const { data: dataEnps } = yield call(getDataEnpsApi, dataStatus.params)
    yield put(getDataNpsSuccess(dataEnps))
  } catch (e) {
    yield put(getDataNpsFailed())
  }
}

// Individual exports for testing
export default function* widgetResultNpsSaga() {
  yield takeLatest(GET_DATA_NPS_WATCHER, getDataNpsSaga)
}
